import * as e from "react";
import r from "../lib/IconBase.es.js";
import a from "../defs/Ticket.es.js";
const o = e.forwardRef((t, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...t, weights: a }));
o.displayName = "TicketIcon";
const s = o;
export {
  s as Ticket,
  o as TicketIcon
};
